<template>
    <div class="col-sm-12 list-content-item mb-2">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-lg-9">
                        <h2 class="title" v-text="shop.name"></h2>
                    </div>
                    <div class="col-lg-3 text-lg-right text-left mt-sm--2 mt-lg-0">
                        PHP<span class="text-lg" v-text="displayedPrice"></span>
                    </div>
                </div>
                <div class="description">Booking No: {{ booking.code }}</div>
                <div class="description">{{penalty.payment_for}}</div>

                <div v-if="isPaid" class="description text-capitalize text-success font-weight-700" v-text="displayedStatus"></div>
                <div v-else class="description text-capitalize text-danger font-weight-700" v-text="displayedStatus"></div>

                <div class="text-right">
                    <a :href="bookingLink" class="btn btn-sm btn-warning">
                        <i class="fa fa-eye mr-1"></i> View Booking
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { resource, pageRoute } from "@utils/network";

export default {
    name: "PenaltiesListItem",

    computed: {
        booking() {
            return this.penalty.booking || {}
        },
        shop() {
            return this.penalty.shop || {};
        },
        bookingLink() {
            return pageRoute("bookings/:id", { id: this.booking.id });
        },
        displayImage() {
            return this.shop.display_image || resource("images/placeholders/avatar.jpg");
        },
        displayedPrice() {
            return parseFloat(this.penalty.price || 0).toFixed(2);
        },
        isPaid() {
            return this.penalty.paid_at != null;
        },
        displayedStatus() {
            return this.isPaid ? "Paid" : "Unpaid";
        },
    },
    
    props: {
        penalty: [Object],
    },
}
</script>